// extracted by mini-css-extract-plugin
export default {"icon":"kb2pGkV5K7PJIfP_GbqQ","transparentBackground":"VkZQB2nuTU938wlUOWUy","hoverStateActive":"wgQ_0nsmxnurVFw9ewob"};